export const AUTH_TOKEN_STORAGE_KEY = 'auth_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'refresh_token';
export const AUTH_CODE = 'authCode';
export const MFA_AUTH_TOKEN = 'mfa_auth_token';
export const MFA_COOKIE = 'mfa_cookie';
export const AUTH_LOGIN_ROUTE = '/auth/login';
